import React, { createContext } from 'react';
import { noop } from '../utility/generic';
import type { TimeSteps } from '../Timeline';

export type TimelineHeadersProviderProps = {
  children: React.JSX.Element;
  rightSidebarWidth?: number;
  leftSidebarWidth: number;
  timeSteps: TimeSteps;
  registerScroll: (el: HTMLDivElement | null) => void;
};

export type TimelineHeadersContext = Omit<
  TimelineHeadersProviderProps,
  'children'
>;

const defaultContextState: TimelineHeadersContext = {
  registerScroll: () => {
    console.warn('default registerScroll header used');
    return noop;
  },
  rightSidebarWidth: 0,
  leftSidebarWidth: 150,
  timeSteps: {
    second: 0,
    minute: 0,
    hour: 0,
    day: 0,
    week: 0,
    isoWeek: 0,
    month: 0,
    year: 0,
  },
};

const { Consumer, Provider } =
  createContext<TimelineHeadersContext>(defaultContextState);

export class TimelineHeadersProvider extends React.Component<TimelineHeadersProviderProps> {
  render() {
    return <Provider value={this.props}>{this.props.children}</Provider>;
  }
}

export const TimelineHeadersConsumer = Consumer;
